// src/providers/GoogleOAuthProvider.jsx
import React from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

const GoogleProvider = ({ children }) => {
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

  if (!clientId) {
    console.error("Google Client ID not found in environment variables");
    return children; // Return children without OAuth if no client ID
  }

  return (
    <GoogleOAuthProvider clientId={clientId}>{children}</GoogleOAuthProvider>
  );
};

export default GoogleProvider;
